import { when } from 'k-ramel'
import * as reactions from './app.reactions'

const listeners = [
  when('@@ui/LOGOUT')(reactions.logout),
  when('@@ui/BUTTON/LOGOUT')(reactions.logout),
  when('@@ui/MENU/ITEM/CLICK')(reactions.goTo),
  when('@@router/PUSH')(reactions.onRouterPush),
]

export default listeners
